// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.arenacxFooterLink[data-v-225df573] {\n\t\tcursor:pointer;\n\t\tfont-weight: 500;\n\t\tcolor: #336b65;\n\t\tmargin-right: 31px;\n\t\tdisplay: inline-block;\n\t\tfont-size: 85%;\n}\n.arenacxFooterLink[data-v-225df573]:hover {\n\t\t\n\t\tcolor: \t#13b196;\n}\n\n", ""]);
// Exports
module.exports = exports;
